module.exports = __webpack_public_path__ + "img/icon-reviews.3717cbc6.png";